// Polyfill pour crypto.randomUUID() compatible avec les anciens navigateurs
export const generateUUID = (): string => {
  // Vérifier si crypto.randomUUID est disponible (navigateurs modernes)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  // Fallback pour les navigateurs plus anciens
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    // Utiliser crypto.getRandomValues pour générer un UUID v4
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    
    // Convertir en format UUID v4
    array[6] = (array[6] & 0x0f) | 0x40; // Version 4
    array[8] = (array[8] & 0x3f) | 0x80; // Variant bits
    
    const hex = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
  }
  
  // Fallback ultime pour les très anciens navigateurs (moins sécurisé)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};